// Do Not Serve (migration 069). The server refuses to add a flagged customer
// to a route with 409 DO_NOT_SERVE unless the request carries
// confirmDoNotServe: true. These helpers keep every add-stop client asking the
// same question in the same words.

// True when an axios error is the server's Do Not Serve refusal, as opposed to
// any other failure. Storm Mode tests this BEFORE its fallback re-POST, so the
// owner is asked once and the fallback never swallows the warning.
export const isDoNotServeConflict = (err) =>
  err?.response?.status === 409 && err?.response?.data?.code === 'DO_NOT_SERVE';

// The confirm text. The reason line is left out when the server sent none,
// which is what a driver or crew lead receives: the reason is the owner's.
export const doNotServeConfirmMessage = (data) => {
  const lines = [`${data?.customerName || 'This customer'} is marked Do Not Serve.`];
  if (data?.reason) lines.push(`Reason: ${data.reason}`);
  lines.push('Add to this route anyway?');
  return lines.join('\n');
};

// Ask once, from a 409 response. Returns true when the user confirmed.
export const confirmDoNotServe = (err) =>
  window.confirm(doNotServeConfirmMessage(err?.response?.data));
